import { useEffect, useState } from 'react';

const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [innerWidth, setInnerWidthPosition] = useState(0);
  const [innerHeight, setInnerHeightPosition] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
      setInnerWidthPosition(window.innerWidth);
      setInnerHeightPosition(window.innerHeight);
      const footer = document.querySelector('footer');
      setFooterHeight(footer?.getBoundingClientRect().height || 0);
      setClientHeight(document.body.clientHeight)
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);
  }, []);
  useEffect(() => {
    const updateInnerWidth = () => {
      setInnerWidthPosition(window.innerWidth);
      setInnerHeightPosition(window.innerHeight);
      const footer = document.querySelector('footer');
      setFooterHeight(footer?.getBoundingClientRect().height || 0);
      setClientHeight(document.body.clientHeight)

    };
    window.addEventListener('resize', updateInnerWidth);
    updateInnerWidth();
    return () => window.removeEventListener('resize', updateInnerWidth);
  }, []);

  return { scrollPosition, innerWidth, innerHeight, footerHeight, clientHeight };
};

export default useScrollPosition;
